import React, { FC } from "react";
import { Button } from "component-library";
import { useTranslation } from "i18n";
import { getTagminSelfTapeUrl } from "pages/SelfTapeRequestPage/SelfTapeRequestAgentParts/helpers";

interface Props {
  selfTapeRequestId: string;
}

const TagminBanner: FC<React.PropsWithChildren<Props>> = ({
  selfTapeRequestId,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-1.5 p-2.5 bg-tagmin-bg border border-tagmin-primary rounded">
      <p className="text-s">
        {t("common:selfTapes.request.sendToClient.tagminBanner.text")}
      </p>
      <Button
        type="primary"
        text={t("common:selfTapes.request.action.openInTagmin")}
        size="medium"
        className="w-auto min-w-[160px] bg-tagmin-primary border-tagmin-primary hover:bg-tagmin-primary hover:border-tagmin-primary"
        onClick={() =>
          window.open(getTagminSelfTapeUrl(selfTapeRequestId), "_blank")
        }
      />
    </div>
  );
};

export default TagminBanner;
